<template>
	<div class="b-sim-card" :class="classes" v-on="$listeners" v-bind="$attrs">
		<div class="b-sim-card__description">
			{{ description }}
		</div>
		<div class="b-sim-card__date">
			{{ formattedDate }}
		</div>
		<div class="b-sim-card__title">
			{{ title }}
		</div>

		<BIcon class="b-sim-card__icon" :name="icon" size="52px" />
	</div>
</template>
<script>
import { formatDate } from "@/utils";
import BIcon from "@/components/base/BIcon";

export default {
	components: {
		BIcon,
	},
	props: {
		variant: {
			type: String,
			default: "primary",
			validator: (value) => ["primary", "secondary"].includes(value),
		},
		date: {
			type: [String, Date],
			default: "",
		},
		title: {
			type: String,
			default: "",
		},
		description: {
			type: String,
			default: "",
		},
		icon: {
			type: String,
			default: "IPlaceholder",
		},
	},
	computed: {
		classes() {
			return [`is-${this.variant}`];
		},
		formattedDate() {
			return this.date ? formatDate(this.date) : "";
		},
	},
};
</script>
<style lang="scss">
.b-sim-card {
	border-radius: 16px;
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	width: 100%;
	padding: 20px;
	row-gap: 31px;
	cursor: pointer;
}

.b-sim-card__date,
.b-sim-card__icon {
	justify-self: flex-end;
}

.b-sim-card__title,
.b-sim-card__icon {
	align-self: flex-end;
}

.b-sim-card__description {
	text-transform: uppercase;
	color: var(--color-primary-200);
	font-size: var(--font-size-2xs);
	font-weight: var(--font-weight-bold);
	letter-spacing: 2px;
}

.b-sim-card__date {
	font-size: var(--font-size-2xs);
	font-weight: var(--font-weight-bold);
}

.b-sim-card__title {
	font-size: var(--font-size-l);
	font-weight: var(--font-weight-regular);
}

.b-sim-card__icon {
	color: var(--color-primary-400);
}

.b-sim-card {
	&.is-primary {
		background: var(--color-primary-600);
		color: #fff;

		.b-sim-card__description {
			color: var(--color-primary-200);
		}

		&:hover {
			background: var(--color-primary-700);
		}

		&:active {
			background: var(--color-primary-800);
		}
	}

	&.is-secondary {
		background: var(--color-neutral-700);
		color: #fff;

		.b-sim-card__description {
			color: var(--color-neutral-200);
		}

		&:hover {
			background: var(--color-neutral-800);
		}

		&:active {
			background: var(--color-neutral-900);
		}
	}
}

@media (max-width: 768px) {
	.b-sim-card {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		row-gap: 0;
	}

	.b-sim-card__description {
		margin-bottom: 4px;
	}

	.b-sim-card__title {
		margin-top: 40px;
		align-self: auto;
	}

	.b-sim-card__date {
		margin-bottom: auto;
	}

	.b-sim-card__icon {
		display: none;
	}
}
</style>
